define(function (require) {
    "use strict";

    var $ = require("jquery");
    var $cookie = require("jquery.cookie");
    var $storage = require("jquery.storage");

    return $;
});